import { socket_url } from "./apiUtils";
import { createAdminSocket } from "./socketConfig";

const socket = createAdminSocket(socket_url, {
  autoConnect: false, // we will connect manually
});

export default socket;
